import axios from '@/libs/axios'

const state = {
  loading: true,
  success: true,
  allowRegistration: true,
  loginEnabled: true,
  version: "",
  totalUsers: 1,
  name: "XAIMED AI",
  socket: null,
  sessionLifetime: null, // Initialize as null instead of default value
  isOnpremise: false,
  isLocalstack: false,
  apiKeyEnv: 'live', // 'live' (prod) 또는 'test' (dev)
  faqUrl: '',
  resultKey: 'XAIFN',
  regulatory: {},
  preApproval: null // null = 아직 모름(/api/info 응답 전·실패): ver·기재사항 숨김
};

const getters = {};

const mutations = {
  // socket(state, connected) {
  //   state.socket = connected;
  // },
  increamentUserCount(state) {
    state.totalUsers++;
  },
  setBranding(state, data) {
    if (data.product_name) {
      state.name = data.product_name;
      var emoji = data.tab_emoji || '';
      var isDev = data.api_key_env === 'test';
      var prefix = isDev ? ' [DEV]' : '';
      document.title = (emoji + prefix + ' ' + data.product_name).trim();
    }
    if (data.faq_url) {
      state.faqUrl = data.faq_url;
    }
    if (data.result_key) {
      state.resultKey = data.result_key;
    }
    if (data.regulatory) {
      state.regulatory = data.regulatory;
    }
  },
  getServerInfo(state) {
    state.loading = true;
    axios
      .get("/api/info/")
      .then(response => {
        state.loading = false;
        state.success = true;

        let data = response.data;
        state.name = data.name;
        // git.tag: #428 A4 이전 백엔드 호환(같은 인허가 값)
        state.version = data.regulatory_version || (data.git && data.git.tag);
        // 필드가 없으면(#428 A4 이전 백엔드) 모름(null) — ver·기재사항·안내 모두 숨김
        state.preApproval = typeof data.pre_approval === 'boolean' ? data.pre_approval : null;
        state.allowRegistration = data.allow_registration;
        state.loginEnabled = data.login_enabled;
        state.totalUsers = data.total_users;
        state.isOnpremise = data.is_onpremise || false;
        state.isLocalstack = data.is_localstack || false;
        state.apiKeyEnv = data.api_key_env || 'live';
        // Get session lifetime from headers
        const sessionLifetime = parseInt(response.headers['x-session-lifetime'])
        if (sessionLifetime) {
          state.sessionLifetime = sessionLifetime
        } else {
          state.sessionLifetime = null
        }
      })
      .catch(() => {
        state.loading = false;
        state.success = true;

        state.version = "unknown";
      });
  }
};

const actions = {
  fetchBranding({ commit }) {
    axios
      .get("/api/system/branding")
      .then(function(response) {
        commit("setBranding", response.data);
      })
      .catch(function() {
        // silently ignore; defaults remain
      });
  }
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};
